module.exports = __webpack_public_path__ + "img/field.9431cbc2.svg";